// import React, { useState, useEffect } from 'react';
// import './Master.css';
// import logo1 from '../Assets/logonew.png';
// import { Popover, TextField, Typography } from '@mui/material';
// import { FaUserCircle } from "react-icons/fa";
// import { AiOutlineLogout } from "react-icons/ai";
// import { RiLockPasswordFill } from "react-icons/ri";
// import { Col, Row, Spinner } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
// import AdminDashboard1 from './AdminDashboard1';

// const NavLogo = () => {
//     const userdata = JSON.parse(sessionStorage.getItem('userdata')) || {};
//     const { branch_id: branchId, branch_name: Name } = userdata;
//     const [loading, setLoading] = useState(false);
//     const [languageSelect, setLanguageSelect] = useState(sessionStorage.getItem('selectedLanguage') || 'English');
//     const [prevLanguage, setPrevLanguage] = useState(languageSelect);
  
//     const handleLanguageChange = (e) => {
//         const selectedLanguage = e.target.value;
//         setLanguageSelect(selectedLanguage);
//         sessionStorage.setItem('selectedLanguage', selectedLanguage);
//     };

//     const [anchorEl, setAnchorEl] = React.useState(null);
//     const handleClickPopover = (event) => {
//         setAnchorEl(event.currentTarget);
//     };
//     const handleClosePopover = () => {
//         setAnchorEl(null);
//     };
//     const open2 = Boolean(anchorEl);
//     const id = open2 ? 'simple-popover' : undefined;
  
//     const navigate = useNavigate();
//     const logoutFun = () => {
//         sessionStorage.clear();
//         navigate('/');
//     }
//     const handlePasswordChange = () => {
//         navigate('/passwordChange');
//     };

//     useEffect(() => {
//         // Check if language changed and reload the page if it did
//         if (prevLanguage !== languageSelect) {
//             window.location.reload();
//         }
//         // Update previous language
//         setPrevLanguage(languageSelect);
//     }, [languageSelect, prevLanguage]);

//     return (
//         <Row className=' py-1 mt-3 mx-2 shadow m-0 p-0 ' style={{ display: "flex", backgroundColor: "white ", borderRadius: "5px " }}>
//             <Col sm={12} md={3} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
//                 <img src={logo1} alt="Logo" style={{ mixBlendMode: "darken" }} width={120} height={80} />
//             </Col>
//             <Col sm={9} md={6} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
//                 <h2 style={{ fontFamily: "sans-serif", letterSpacing: "2px", color: " rgb(47, 79, 79)" }}><b>{Name}</b></h2>
//             </Col>
//             <Col sm={3} md={3} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
//                 <FaUserCircle style={{ fontSize: 30, color: "rgb(47, 79, 79)" }} title='Profile' aria-describedby={id} variant="contained" onClick={handleClickPopover} />
//                 <Popover
//                     id={id}
//                     open={open2}
//                     anchorEl={anchorEl}
//                     onClose={handleClosePopover}
//                     anchorOrigin={{
//                         vertical: 'bottom',
//                         horizontal: 'left',
//                     }}
//                 >
//                     <Typography> <button className='profileButton' onClick={handlePasswordChange}>Change Password &nbsp; <RiLockPasswordFill /></button> </Typography>
//                     <Typography> <button className='profileButton' onClick={logoutFun}>Logout &nbsp;<AiOutlineLogout /></button> </Typography>
//                 </Popover>
//                 <TextField
//                     id="demo-simple-select"
//                     size="small"
//                     label="Select Language"
//                     select
//                     className="ms-md-4 ms-2"
//                     value={languageSelect}
//                     onChange={handleLanguageChange}
//                     variant="outlined"
//                     fullWidth
//                     SelectProps={{
//                         native: true,
//                     }}
//                 >
//                     <option value="" disabled></option>
//                     <option value="English">English</option>
//                     <option value="Marathi">Marathi</option>
//                 </TextField>
//             </Col>
//         </Row>
//     );
// }

// export default NavLogo;








import React, { useState, useEffect } from 'react';
import './Master.css';
import logo1 from '../Assets/logonew.png';
import { Popover, TextField, Typography } from '@mui/material';
import { FaUserCircle } from "react-icons/fa";
import { AiOutlineLogout } from "react-icons/ai";
import { RiLockPasswordFill } from "react-icons/ri";
import { Col, Row, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AdminDashboard1 from './AdminDashboard1';

const NavLogo = () => {
    const userdata = JSON.parse(sessionStorage.getItem('userdata')) || {};
    let { branch_id: branchId, branch_name: Name, mrbranch_name: MarathiName } = userdata;
    const selectedLanguage = sessionStorage.getItem('selectedLanguage');
    // If Marathi language is selected, use 'mrbranch_name', else use 'branch_name'
    const displayName = selectedLanguage === 'Marathi' ? MarathiName : Name;
    
 
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClickPopover = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClosePopover = () => {
        setAnchorEl(null);
    };
    const open2 = Boolean(anchorEl);
    const id = open2 ? 'simple-popover' : undefined;
  
    const navigate = useNavigate();
    const logoutFun = () => {
        sessionStorage.clear();
        navigate('/');
    }
    const handlePasswordChange = () => {
        navigate('/passwordChange');
    };


    return (
        <Row className=' py-1 mt-3 mx-2 shadow m-0 p-0 ' style={{ display: "flex", backgroundColor: "white ", borderRadius: "5px", }}>
            <Col sm={12} md={3} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <img src={logo1} alt="Logo" style={{ mixBlendMode: "darken" }} width={120} height={80} />
            </Col>
            <Col sm={9} md={6} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <h2 style={{ fontFamily: "sans-serif", letterSpacing: "2px", color: " rgb(47, 79, 79)" }}><b>{displayName }</b></h2>
            </Col>
            <Col sm={3} md={3} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <FaUserCircle style={{ fontSize: 30, color: "rgb(47, 79, 79)",cursor:"pointer" }} title='Profile' aria-describedby={id} variant="contained" onClick={handleClickPopover} />
                <Popover
                    id={id}
                    open={open2}
                    anchorEl={anchorEl}
                    onClose={handleClosePopover}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Typography> <button className='profileButton' onClick={handlePasswordChange}>Change Password &nbsp; <RiLockPasswordFill /></button> </Typography>
                    <Typography> <button className='profileButton' onClick={logoutFun}>Logout &nbsp;<AiOutlineLogout /></button> </Typography>
                </Popover>
            </Col>
        </Row>
    );
}

export default NavLogo;
